module.exports = __webpack_public_path__ + "img/img6.3e5d12ef.png";